import React from 'react'
import { findDOMNode } from 'react-dom'
import moment from 'moment'
import numeral from 'numeral'
import _ from 'underscore'
import dynamics from 'dynamics.js'

import MultiAllocation from '../components/multi-allocation'

import AutoComplete from '../components/react-autocomplete'
import NumericTextBox from '../components/react-numerictextbox'

export default class TicketWidget extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			savedLayout : props.savedLayout || {},

			order : props.order || {
				side: 'BUY',
				symbol : '',

				text : '',
			},

			instrument : {},
			quote : {},
			accounts : [],

			is_loaded :     false,
			is_submitting : false,
		}

		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentWillUnmount() {
    if (this._px_socket) this._px_socket.close()
		this._px_socket = undefined
  }

	componentDidMount() {
    //layout
    if (this.props.onResize)
      this.props.onResize(515,360)

    //sockets
    realtime().then( (socket) => {
      this._px_socket = socket

			socket.onclose = (e) => {
				if (e.wasClean != true)
					raiseAlert("CONNECTION LOST: " + e.code + " " + e.reason)
			}
			socket.onjson = (m) => {
				if (!(m.symbol)) return
				if (m.symbol != this.state.symbol) {
					this._px_socket.unsubscribe("pricefeed.Quote.RIC:" + m.symbol)
					return
				}
				Object.assign(this.state.quote, m)
				//this.renderQuote(m)
			}

    	})


		var loadOrderWorkflow = []
		if (this.props.order) {
			loadOrderWorkflow.push(
				// load allocations
				api('/order/allocation?clOrdId='+this.props.order.clOrdId)
					.then( (res) => {
						if (Array.isArray(res)) {
							this.props.order.allocations = res
						}
					})
			)

			loadOrderWorkflow.push(
				// load order instrument
		  	    api('/instrument?internal_id='+this.props.order.instrument.instrument_id)
		  	      .then( (res) => {
		            if (res.instrument_id && res.definition) {
		            	res.description = res.description || res.symbol
						this.setState({
							instrument : res,
						})
		            }
		          })
			)
		}

		//Finally render controls
		Promise.all(loadOrderWorkflow)
			.then( (res) => {
				this.setState({
					is_loaded  : true
				}, () => this.initControls())
			})
	}

	initControls() {
		let self = this

		$(this.refs.optSide).kendoDropDownList({
				dataSource: [
					{ text: 'BUY', value: 'BUY' },
					{ text: 'SELL', value: 'SELL' },
					{ text: 'SELL Short', value: 'SELL_SHORT' },
					{ text: 'SUBSCRIBE', value: 'SUBSCRIBE' },
					{ text: 'REDEEM', value: 'REDEEM' },
				],
				dataTextField: "text",
				dataValueField: "value",
				enable: (this.state.order.order_id ? false : true),

				change: function(e) {
					var value = this.value()

					self.state.order.side = value
					self.setState({
						order : Object.assign({}, self.state.order)
					})
				},
		});
		$(this.refs.optSide).data("kendoDropDownList").value(this.state.order.side)


		$(this.refs.txtInstrumentSearch).kendoAutoComplete({
	      dataTextField: "description",
	      template: '<span class="btn btn-xs btn-default" title="#= instrument_id #">#= product_type #</span> #= description #, <i>#= symbol #</i>',
	      placeholder: "Search by symbol or description ...",
	      filter: "contains",
	      minLength: 2,
	      dataSource: (this.state.order.order_id ? [this.state.instrument] : {
	          serverFiltering: true,
	          transport: {
	            read: function(opts) {
	              var searchTerm = opts.data.filter.filters[0].value
	              api('/instrument/search?term='+escape(searchTerm))
	        	      .then( (res) => {
	                  opts.success(res)
	                }).catch( (e) => {opts.error(e)} )
	            }
	          }
	      }),
	      enable: (this.state.order.order_id ? false : true), value: (this.state.order.order_id ? this.state.instrument.description : ""),
	      select: function(e) {
	        var item = this.dataItem(e.item.index())
	  	    api('/instrument?symbol='+item.symbol)
	  	      .then( (res) => {
	            if (res.instrument_id && res.definition) {
								self.setState({
									instrument : res,
									accounts: [],
								})

						    api('/account', {
										method: 'POST',
										body : JSON.stringify({instrument_id: res.instrument_id})
									})
						      .then( (res) => {
										console.log('accounts', res)
										if (Array.isArray(res) == false) return

										self.setState({
											accounts : res,
										})
									})
	            }
	          })
	      }
	  })

	}

	updateTitle() {
		let description = this.state.quote.description || this.state.instrument.description || ''
		if (!(this.state.instrument.instrument_id))
			description = '<span class="btn-xs status R" title="Instrument Unknown">#REF!</span>' + description

		if (this.props.onTitle) {
			this.props.onTitle(description)
		}
	}

	saveLayout() {
		if (window.updateLayout) {
			if (this.state.symbol)
				window.updateLayout({
					symbol : this.state.symbol,
				})
		}
	}

  render() {
	if (! this.state.is_loaded) {
			return <div>loading...</div>
	}
  return (
    <div ref="widget" className="widget">

        <div ref="orderbar" className="orderbar" style={{textAlign:'left',background: 'rgba(255, 255, 255, 0.03)', padding:'1em 0.2em'}}>
						<div className="control">
								<span className="label">Side</span>
								<select ref="optSide" style={{ width : '8.1em' }}></select>
						</div>
            <div className="control" style={{marginLeft:'0.5em'}}>
                <span className="label">Security</span>
								<input ref="txtInstrumentSearch"  style={{width:200}}></input>
            </div>
            <div className="control" style={{marginLeft:'0.5em'}}>
                <span className="label">Quantity</span>
                <NumericTextBox ref="txtQuantity" width={ 100 } decimals={0} format='n0' min={0}
                				disabled={ (this.state.order.order_id ? true : false) } initialValue={this.state.order.quantity}/>
            </div>
						<div className="control">
								<span className="label">Limit Price</span>
								<NumericTextBox ref="txtLimitPrice" width={ 90 } decimals={9} format='#.##########'
										step={0.01} min={0}
										disabled={ (this.state.order.order_id ? true : false) } initialValue={this.state.order.limit_price} />
						</div>

						<div className="control fillWidth">
              <span className="label">Note</span>
							<textarea value={this.state.order.text} placeholder="(1500 characters maximum)"
							 					onChange={ (e) => {
													let value = e.target.value
													this.state.order.text = value
													this.setState({
														order: Object.assign({}, this.state.order)
													})
												}}/>
						</div>
        </div>

				{
					(this.state.instrument && this.state.instrument.definition ?
						<table className="table" style={{marginTop:"1em"}}>
							<tr>
								<td><span style={propertyNameStyle}>Symbol</span><span style={propertyValueStyle}>{this.state.instrument.symbol}</span></td>
								<td><span style={propertyNameStyle}>Description</span><span style={propertyValueStyle}>{this.state.instrument.description}</span></td>
								<td><span style={propertyNameStyle}>Last</span><span style={propertyValueStyle}></span></td>
								<td><span style={propertyNameStyle}>Bid</span><span style={propertyValueStyle}></span></td>
								<td><span style={propertyNameStyle}>Ask</span><span style={propertyValueStyle}></span></td>
							</tr>
							<tr>
								<td><span style={propertyNameStyle}>CCY</span><span style={propertyValueStyle}>{this.state.instrument.ccy}</span></td>
								<td><span style={propertyNameStyle}>ISIN</span><span style={propertyValueStyle}>{this.state.instrument.definition.isin}</span></td>
								<td><span style={propertyNameStyle}>Lot</span><span style={propertyValueStyle}>{this.state.instrument.roundlot}</span></td>
								<td><span style={propertyNameStyle}>Low</span><span style={propertyValueStyle}></span></td>
								<td><span style={propertyNameStyle}>High</span><span style={propertyValueStyle}></span></td>
							</tr>
							<tr>
								<td><span style={propertyNameStyle}>Exch</span><span style={propertyValueStyle}>{this.state.instrument.definition.exchange_mic}</span></td>
								<td><span style={propertyNameStyle}>Country</span><span style={propertyValueStyle}>{this.state.instrument.definition.country}</span></td>
								<td colSpan={2}><span style={propertyNameStyle}>Sector</span><span style={propertyValueStyle}>{this.state.instrument.definition.sector}</span></td>
							</tr>
						</table>
					: undefined )
				}

				<div className="" style={{marginTop:'1em',background: 'rgba(255, 255, 255, 0.03)', padding:'1em 0.2em'}}>
					<MultiAllocation ref="allocations" instrument={this.state.instrument} initialAllocations={this.state.order.allocations}
									 				 disabled={ (this.state.order.order_id ? true : false) } />
        </div>

				{
					(this.state.order.order_id ? undefined :
							<div style={{textAlign: 'center', padding: '1em'}}>
								<button className="default lg"
												onClick={ this.handleSubmit }
												disabled={ this.state.is_submitting }
												style={{}}>
										Submit Ticket
								</button>
							</div>
					)
				}

    </div>
    );
  }

	// SUBMIT ACTIONS =============================================================

		handleSubmit() {
			if (this.state.is_submitting) return
			if (!this.state.instrument.instrument_id) return

			let errors = []
			let order = {
				//clOrdId      : window.GUID(),
				side            : this.state.order.side,
				security_id_source : '_DEF', 												// avoid instrument lookup
				security_id     : JSON.stringify(Object.assign({},
															_.omit(this.state.instrument, 'definition'),
															_.pick(this.state.instrument.definition,
																		 'exchange_mic','isin','sedol')
														  )
													),
				quantity        : this.refs.txtQuantity.getValue(),

				order_type       : 'LIMIT',
				limit_price      : this.refs.txtLimitPrice.getValue(),

				timeinforce      : 'DAY',
				text             : this.state.order.text,
			}

			if (_.isNumber(order.quantity) == false)
				errors.push('Invalid quantity')
			if (order.order_type == 'LIMIT')
				if (order.limit_price == null || +(order.limit_price) == 0)
					order.order_type = 'MARKET'
			if (order.order_type == 'LIMIT')
				if (_.isNumber(order.limit_price) == false)
					errors.push('Invalid limit price')
			if (order.order_type == 'MARKET')
				delete order.limit_price;
			if (order.order_type == 'STOP')
				delete order.limit_price;

			// Account
			// we can only support Internal account
			let account = _.find(this.state.accounts, { account : 'INTERNAL' });
			if (account) {
				order.account_id = account.account_id;
				order.account = account.account;
				order.market_connector = account.market_connector;

				if (order.market_connector === undefined)
					errors.push('Invalid market connector');
			} else {
				errors.push('Internal account not available');
			}

			// Allocations
			order.allocations = this.refs.allocations.getAllocations()

			if (errors.length > 0) {
				raiseAlert(_.reduce(errors, (result, val) => { return result + '\n' + val }, "ERROR: Could not submit order\n "))
				return;
			}

			console.log("SUBMIT TICKET =>", order);
			this.state.is_submitting = true
			this.setState({
				is_submitting : true
			})

	    api('/order', {
					method: 'POST',
					body : JSON.stringify(order)
				})
	      .then( (response) => {
	        this.setState({
	        	is_submitting : false
	        })

					console.log(response)
					if (!response.order_key && response.detail) {
						raiseAlert(response.detail)
					} else if (response.ok == false && response.errors) {
						// Complaince Fail
						let htmlContent = `
						<div class="alarming">LIMIT BREACH</div>
						<table class='table table-hover'>
						<thead>
							<tr>
								<td>description</td>
								<td>constraint</td>
								<td style="text-align:right;">⇤</td>
								<td style="text-align:right;">value</td>
								<td style="text-align:right;">⇥</td>
							</tr>
						</thead>
						<tbody>
						`
						for (var i = 0; i < response.errors.length; i++) {
							let detail = response.errors[i]
							if (detail.rule_name && detail.constraint_name) {
								detail.constraint_lbound = numeral(detail.constraint_lbound).format('0,0[.][0]0')
								detail.constraint_value = numeral(detail.constraint_value).format('0,0[.][0]0')
								detail.constraint_ubound = numeral(detail.constraint_ubound).format('0,0[.][0]0')
								htmlContent += `<tr title="${detail.text}">
									<td>${detail.rule_name}</td>
									<td>${detail.constraint_name}</td>
									<td style="text-align:right;${detail.text.indexOf('LowerBound breach') == 0 ? 'color: red' : ''}">${detail.constraint_lbound}</td>
									<td style="color: #ff6e00;text-align:right;">${detail.constraint_value}</td>
									<td style="text-align:right;${detail.text.indexOf('UpperBound breach') == 0 ? 'color: red' : ''}">${detail.constraint_ubound}</td>
								</tr>`
							} else {
								htmlContent += `<tr>
									<td colspan="5">${detail.text}</td>
								</tr>`
							}
						}
						htmlContent += `
						</tbody>
						</table>`

						raiseAlert(htmlContent)
					}
				})

		}
}

const propertyNameStyle = {
  float: 'left',
	paddingLeft: '1em',
  fontSize: '0.9em',
  color: '#9C9C9C',
};
const propertyValueStyle = {
  float: 'right',
	paddingRight: '1em',
};



// WEBPACK FOOTER //
// ./src/widgets/ticket.jsx